import React, { useEffect, useState } from 'react';
import { BookingApi } from 'shared/api';
import { businessStore } from 'entities/index';
import { IDayFreeSlots } from 'shared/api/booking/interfaces/day-free-slots.interface';
import * as dateFns from 'date-fns';
import { useParams } from 'react-router-dom';
import { DATE_FORMAT } from 'shared/consts/date-format';
import styles from './step-time.module.scss';

interface IStepTime {
  employeeId?: string;
  serviceId?: string;
  date: Date;
  selectedTime?: string;
  onSelect: (time: string) => void;
}

export const StepTime: React.FC<IStepTime> = ({
  employeeId,
  serviceId,
  date,
  selectedTime,
  onSelect,
}) => {
  const [timeSlots, setTimeSlots] = useState<IDayFreeSlots>();
  const params = useParams();
  const pointId = businessStore.pointId || params.pointId;

  useEffect(() => {
    fetchSlots();
  }, [date, serviceId, pointId]);

  const fetchSlots = async () => {
    if (date && serviceId && pointId) {
      const params: any = {
        date: dateFns.format(date, DATE_FORMAT),
        serviceId,
        pointId,
        currentDateTime: dateFns.format(new Date(), "yyyy-MM-dd'T'HH:mm:ssxxx"),
      };
      if (employeeId) {
        params.employeeId = employeeId;
      }
      try {
        const slots = await BookingApi.getDayFreeSlots(params);
        setTimeSlots(slots);
      } catch {
        setTimeSlots(undefined);
      }
    } else {
      setTimeSlots(undefined);
    }
  };

  if (!timeSlots) {
    return <div className={styles.selected__content}>Нет свободных слотов</div>;
  }

  const segments = [
    { label: 'Ночь', from: 0, to: 6 },
    { label: 'Утро', from: 6, to: 12 },
    { label: 'День', from: 12, to: 18 },
    { label: 'Вечер', from: 18, to: 24 },
  ];

  const getSegmentLabel = (time: string): string | undefined => {
    const hour = parseInt(time.split(':')[0], 10);
    return segments.find((s) => hour >= s.from && hour < s.to)?.label;
  };

  const sortedEntries = Object.entries(timeSlots).sort(([a], [b]) =>
    a.localeCompare(b)
  );

  return (
    <div className={styles.selector__content}>
      {selectedTime && !(selectedTime in timeSlots) && (
        <div
          onClick={() => onSelect(selectedTime)}
          className={`${styles.content__slot} ${styles.slot__unavailable}`}
        >
          <div className={styles.slot__text}>
            {selectedTime} <span className={styles.unavailable}>(занято)</span>
          </div>
        </div>
      )}
      {sortedEntries.map(([slotTime], index) => {
        const segment = getSegmentLabel(slotTime);
        const prevSegment =
          index > 0 ? getSegmentLabel(sortedEntries[index - 1][0]) : undefined;
        const showTitle = segment && segment !== prevSegment;

        return (
          <React.Fragment key={slotTime}>
            {showTitle && (
              <div className={styles.segment__title}>{segment}</div>
            )}
            <div
              onClick={() => onSelect(slotTime)}
              className={`${styles.content__slot} ${selectedTime === slotTime ? styles.slot__selected : ''}`}
            >
              <div className={styles.slot__text}>{slotTime}</div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
